/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlFixedFindingsResult } from './ControlFixedFindingsResult';
import {
    ControlFixedFindingsResultFromJSON,
    ControlFixedFindingsResultFromJSONTyped,
    ControlFixedFindingsResultToJSON,
} from './ControlFixedFindingsResult';

/**
 * 
 * @export
 * @interface ControlPaginatedFixedFindingsResponse
 */
export interface ControlPaginatedFixedFindingsResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedFixedFindingsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedFixedFindingsResponse
     */
    page_size?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedFixedFindingsResponse
     */
    count?: number;
    /**
     * 
     * @type {Array<ControlFixedFindingsResult>}
     * @memberof ControlPaginatedFixedFindingsResponse
     */
    results: Array<ControlFixedFindingsResult>;
}

/**
 * Check if a given object implements the ControlPaginatedFixedFindingsResponse interface.
 */
export function instanceOfControlPaginatedFixedFindingsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function ControlPaginatedFixedFindingsResponseFromJSON(json: any): ControlPaginatedFixedFindingsResponse {
    return ControlPaginatedFixedFindingsResponseFromJSONTyped(json, false);
}

export function ControlPaginatedFixedFindingsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedFixedFindingsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'results': ((json['results'] as Array<any>).map(ControlFixedFindingsResultFromJSON)),
    };
}

export function ControlPaginatedFixedFindingsResponseToJSON(value?: ControlPaginatedFixedFindingsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'count': value.count,
        'results': ((value.results as Array<any>).map(ControlFixedFindingsResultToJSON)),
    };
}

